import React from 'react';
import { Routes, Route } from 'react-router-dom';
import PrivateRoute from './PrivateRoute';
import {
  Home, 
  About, 
  Login,
  Signup,
  MobileVerification,
  Dashboard,
  DashboardV2,
  UnattemptedQuizzes,
  MockTest,
  MockQuizList,
  MockQuizDetails,
  HomeV2,
  SuccessStories,
  Profile,
  Performance,
  ReportCard,
  CustomQuizGenerator,
  CustomQuizHistory,
  PYQQuizGenerator,
  PYQHistory,
  QuizPage,
  QuizResults,
  DetailedQuizResults,
  PreviousYearPapers,
  AITutor,
  StudyPlan,
  BasicInfo,
  SubjectScores,
  StudyPreferences,
  SleepSchedule,
  Commitments,
  AccountSettings,
  DeleteAccountInfo,
  WhatWeDo,
  OurManagement,
  Partnerships,
  Contact,
  SubscriptionPlans,
  Payment,
  BlogList,
  BlogPost,
  NotFound, 
  WaterTreatmentPlants, 
  SanyolWtSpecilityChemicals,
  DesignAndConsultancy,
  OperationAndMaintenance,
  RevampingOfWaterTreatmentPlants,
  WastewaterTreatmentSolutions,
  HeavyIndustries,
  PrivacyPolicy,
  TermsOfService,
  CancellationRefund,
  AIDisclaimers,
  WiziQuizList,
  WiziQuizPage,
  WiziQuizResults
} from '../pages';

const AppRoutes: React.FC = () => {
  return (
    <Routes>
      {/* Public Routes */}
      <Route path="/" element={<HomeV2 />} />
      <Route path="/home-v2" element={<Home />} />
      <Route path="/about" element={<About />} />
      <Route path="/success-stories" element={<SuccessStories />} />
      <Route path="/login" element={<Login />} />
      <Route path="/signup" element={<Signup />} />
      <Route path="/benefits" element={<Signup />} />
      <Route path="/features" element={<Signup />} />
      <Route path="/demo" element={<Signup />} />
      <Route path="/contact" element={<Contact />} />
      <Route path="/pricing" element={<SubscriptionPlans />} />
      <Route path="/delete-account" element={<DeleteAccountInfo />} />
      
      {/* Blog Routes */}
      <Route path="/blog" element={<BlogList />} />
      <Route path="/blog/:slug" element={<BlogPost />} />
      
      {/* Mobile Verification - Semi-Protected (requires auth but bypasses mobile check) */}
      <Route path="/verify-mobile" element={
        <PrivateRoute>
          <MobileVerification />
        </PrivateRoute>
      } />
      
      {/* Policy Pages */}
      <Route path="/privacy-policy" element={<PrivacyPolicy />} />
      <Route path="/terms" element={<TermsOfService />} />
      <Route path="/cancellation-refund" element={<CancellationRefund />} />
      <Route path="/ai-disclaimers" element={<AIDisclaimers />} />
      
      {/* Private Routes - Require Authentication */}
      <Route path="/payment" element={
        <PrivateRoute>
          <Payment />
        </PrivateRoute>
      } />
      <Route path="/dashboard-old" element={
        <PrivateRoute>
          <Dashboard />
        </PrivateRoute>
      } />
      <Route path="/dashboard" element={
        <PrivateRoute>
          <DashboardV2 />
        </PrivateRoute>
      } />
      <Route path="/unattempted-quizzes" element={
        <PrivateRoute>
          <UnattemptedQuizzes />
        </PrivateRoute>
      } />
      <Route path="/mock-quiz" element={
        <PrivateRoute>
          <MockQuizList />
        </PrivateRoute>
      } />
      <Route path="/mock-quiz/:quizId" element={
        <PrivateRoute>
          <MockQuizDetails />
        </PrivateRoute>
      } />
      <Route path="/profile" element={
        <PrivateRoute>
          <Profile />
        </PrivateRoute>
      } />
      <Route path="/performance" element={
        <PrivateRoute>
          <Performance />
        </PrivateRoute>
      } />
      <Route path="/report-card" element={
        <PrivateRoute>
          <ReportCard />
        </PrivateRoute>
      } />
      <Route path="/custom-quiz-generator" element={
        <PrivateRoute>
          <CustomQuizGenerator />
        </PrivateRoute>
      } />
      <Route path="/custom-quiz-history" element={
        <PrivateRoute>
          <CustomQuizHistory />
        </PrivateRoute>
      } />
      <Route path="/pyq-quiz-generator" element={
        <PrivateRoute>
          <PYQQuizGenerator />
        </PrivateRoute>
      } />
      <Route path="/pyq-history" element={
        <PrivateRoute>
          <PYQHistory />
        </PrivateRoute>
      } />
      <Route path="/quiz/:quizReference" element={
        <PrivateRoute>
          <QuizPage />
        </PrivateRoute>
      } />
      <Route path="/quiz-results/:quizReference" element={
        <PrivateRoute>
          <QuizResults />
        </PrivateRoute>
      } />
      <Route path="/quiz-results-detailed/:quizReference" element={
        <PrivateRoute>
          <DetailedQuizResults />
        </PrivateRoute>
      } />
      <Route path="/previous-year-papers" element={
        <PrivateRoute>
          <PreviousYearPapers />
        </PrivateRoute>
      } />
      <Route path="/ai-tutor" element={
        <PrivateRoute>
          <AITutor />
        </PrivateRoute>
      } />
      <Route path="/study-plan" element={
        <PrivateRoute>
          <StudyPlan />
        </PrivateRoute>
      } />
      
      {/* WiZi Quiz Routes */}
      <Route path="/mock-test" element={
        <PrivateRoute>
          <WiziQuizList />
        </PrivateRoute>
      } />
      <Route path="/mock-test/attempt/:attemptId" element={
        <PrivateRoute>
          <WiziQuizPage />
        </PrivateRoute>
      } />
      <Route path="/mock-test/result/:attemptId" element={
        <PrivateRoute>
          <WiziQuizResults />
        </PrivateRoute>
      } />
      
      {/* Profile Pages Routes */}
      <Route path="/profile/basic-info" element={
        <PrivateRoute>
          <BasicInfo />
        </PrivateRoute>
      } />
      <Route path="/profile/subject-scores" element={
        <PrivateRoute>
          <SubjectScores />
        </PrivateRoute>
      } />
      <Route path="/profile/study-preferences" element={
        <PrivateRoute>
          <StudyPreferences />
        </PrivateRoute>
      } />
      <Route path="/profile/sleep-schedule" element={
        <PrivateRoute>
          <SleepSchedule />
        </PrivateRoute>
      } />
      <Route path="/profile/commitments" element={
        <PrivateRoute>
          <Commitments />
        </PrivateRoute>
      } />
      <Route path="/profile/account-settings" element={
        <PrivateRoute>
          <AccountSettings />
        </PrivateRoute>
      } />
      
      {/* Legacy Routes - Can be removed for WiZiAi */}
      <Route path="/what-we-do" element={<WhatWeDo />} />
      <Route path="/our-management" element={<OurManagement />} />
      <Route path="/partnerships" element={<Partnerships />} />
    
      <Route path="/water-treatment-plants" element={<WaterTreatmentPlants />} />
      <Route path="/sanyol-wt-specility-chemicals" element={<SanyolWtSpecilityChemicals />} />
      <Route path="/design-and-consultancy" element={<DesignAndConsultancy />} />
      <Route path="/operation-and-maintenance" element={<OperationAndMaintenance />} />
      <Route path="/revamping-of-water-treatment-plants" element={<RevampingOfWaterTreatmentPlants />} />
      <Route path="/wastewater-treatment-solutions" element={<WastewaterTreatmentSolutions />} />
      <Route path="/heavy-industries" element={<HeavyIndustries />} />

      <Route path="*" element={<NotFound />} />
    </Routes>
  );
};

export default AppRoutes;
